//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"AxialDistance",1,0],[0,"Distance",1,0],[0,"DistanceType",1,0],[0,"EndDistance",1,0],[0,"Method",1,0],[0,"Mode",1,0],[0,"RadialDistance",1,0],[0,"StartDistance",1,0],[0,"VariableStock",0,"CAM.BoundaryTurnVariableStock",0],[0,"Vector",1,"NXObject",0],[0,"VectorDistance",1,0]],[],[]];
SPLM.CAM.BoundaryTurnMemberOffset = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BoundaryTurnMemberOffset";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.BoundaryTurnMemberOffset.ModeType = Object.freeze({
    "None" : "None", "General" : "General", "Tolerance" : "Tolerance", "Legacy" : "Legacy"});

SPLM.CAM.BoundaryTurnMemberOffset.MethodType = Object.freeze({
    "Constant" : "Constant", "Axial" : "Axial", "Vector" : "Vector", "Conical" : "Conical", "Variable" : "Variable"});

SPLM.CAM.BoundaryTurnMemberOffset.DistanceTypeMode = Object.freeze({
    "Nominal" : "Nominal", "Diameter" : "Diameter"});

export default SPLM;